var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { all } from '../../logic/all';
import { any } from '../../logic/any';
/**
 * Returns true if the value is null or undefined
 *
 * @aka isNull
 * @since v2.27.0
 * @category Value
 * @param {*} value - The value to check
 * @returns {boolean}
 * @example
 * isNill(null)       //=> true
 * isNill(undefined)  //=> true
 * isNill('')         //=> false
 * isNill([])         //=> false
 * isNill({})         //=> false
 *
 * // if ANY isNill:
 * isNil.any('test', 0, 1, ['test'], null) //=> true
 *
 * // if ALL isNill:
 * isNil.all(undefined, null) //=> true
 * @docgen_example
 * isNill(null);
 */
var isNil = function (value) { return value === undefined || value === null; };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
isNil.any = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return any.apply(void 0, __spreadArray([isNil], args, false));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
isNil.all = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return all.apply(void 0, __spreadArray([isNil], args, false));
};
export { isNil };
